// Router.jsx
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import CompanyMainPage from "./Pages/CompanyMainPage";
import DashboardMainPage from "./Pages/DashboardMainPage";
import CompanyDataListMain from "./Pages/CompanyDataListMain";
import CertificationPage from "./Pages/CertificationPage";
import AddNewCertificationPage from "./Pages/AddNewCertificationPage";
import ViewPage from "./components/Certification/view/ViewPage";
import EditPage from "./components/Certification/edit/EditPage";
import CertificationTable from "./components/Certification/certification page/CertificationTable";
import SurvellianceMainpage from "./Pages/SurvellianceMainpage";
import RemainderTable from "./components/Survelliance audit/remainder/RemainderTable";
import SecondSurvellianceMainPage from "./Pages/SecondSurvellianceMainPage";
import RemainderTablePage from "./components/Second survelliance audit/remainder page/RemainderTablePage";
import ExpiredCertificationPage from "./Pages/ExpiredCertificationPage";
import AgentsTablePage from "./Pages/AgentsTablePage";
import Login from "./components/Authentication/Login";
import UserTablePageMain from "./Pages/UserTablePageMain";
import Register from "./components/Authentication/Register";
import OtpVerification from "./components/Authentication/OtpVerification";
import ForgotPassword from "./components/Authentication/ForgotPassword";
import CreateNewPassword from "./components/Authentication/CreateNewPassword";
import DetailsTable from "./components/company data list/details/DetailsTable";
import AuditsTable from "./components/company data list/audits/AuditsTable";
import NotificationTableMain from "./Pages/notificationPage/NotificationTableMain";
import ReportsMainPage from "./Pages/reports main page/ReportsMainPage";
import ExpiredCertifications from "./components/Reports/ExpiredCertifications";
import AuditSurvellianceReport from "./components/Reports/AuditSurvellianceReport";
import RenewalStatusReport from "./components/Reports/RenewalStatusReport";
import ComapanyDataCertification from "./components/company data list/ComapanyDataCertification";
import ProtectedRoute from "./ProtectedRoute";
import { IndividualTraineePage } from "./Pages/IndividualTrainee/IndividualTraineePage";
import AddIndividualTrainee from "./components/IndividualTrainee/AddIndividualTrainee";
import EditIndividualTrainee from "./components/IndividualTrainee/EditIndividualTrainee";
import ViewIndividualPage from "./components/IndividualTrainee/ViewIndividualTrainee";
import SettingsMainPage from "./Pages/Settings page/SettingsMainPage";
import RenewCertificationMainPage from "./Pages/renewcertification/RenewCertificationMainPage";
import AddNewRenewCertification from "./components/Renewed certifications/AddCertification";
import ViewRenewCertificationPage from "./components/Renewed certifications/ViewRenewCertification";
import EditRenewdCertificationPage from "./components/Renewed certifications/EditRenewCertification";
 


const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register-page" element={<Register />} />
        <Route path="/otp-verification" element={<OtpVerification />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/create-password" element={<CreateNewPassword />} />
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<DashboardMainPage />} />
          <Route path="/companies" element={<CompanyMainPage />} />
          <Route path="/audits/companies" element={<AuditsTable />} />
          <Route path="/details-page/companies" element={<DetailsTable />} />
          <Route
            path="/company-details/:id"
            element={<CompanyDataListMain />}
          />
          <Route path="/certification" element={<CertificationPage />} />
          <Route
            path="/individual-trainee-page"
            element={<IndividualTraineePage />}
          />
            <Route
            path="/add-new-individual-certification"
            element={<AddIndividualTrainee />}
          />
          <Route path="/edit-individual-certification/:id" element={<EditIndividualTrainee />} />
          <Route path="/view-individual-certification/:id" element={<ViewIndividualPage />} />

          <Route
            path="/addnewcertification"
            element={<AddNewCertificationPage />}
          />
          <Route path="/view-certification/:id" element={<ViewPage />} />
          <Route path="/edit-certification/:id" element={<EditPage />} />
          <Route
            path="/survelliance-audit-one"
            element={<SurvellianceMainpage />}
          />
          <Route path="/remainder-page" element={<RemainderTable />} />
          <Route
            path="/second-survelliance-audit"
            element={<SecondSurvellianceMainPage />}
          />
          <Route
            path="/second-survelliance-audit-remainder"
            element={<RemainderTablePage />}
          />
          <Route
            path="/expired-certifications"
            element={<ExpiredCertificationPage />}
          />
          <Route path="/renewed-certification-page" element={<RenewCertificationMainPage/>}/>
          <Route path="/add-renew-certification" element={<AddNewRenewCertification/>}/>
          <Route path="/view-renewed-certification/:id" element={<ViewRenewCertificationPage />} />
          <Route path="/edit-renewed-certification/:id" element={<EditRenewdCertificationPage />}/>

          <Route path="/agents-page" element={<AgentsTablePage />} />
          {/* Protected route - only admin can access */}
          <Route
            path="/usertable-page"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <UserTablePageMain />
              </ProtectedRoute>
            }
          />{" "}
          <Route
            path="/notification-table/notification"
            element={<NotificationTableMain />}
          />
          <Route path="/reports-page" element={<ReportsMainPage />} />
          <Route
            path="/expired-certifications-reports"
            element={<ExpiredCertifications />}
          />
          <Route
            path="/audit-survelliance-page/reports"
            element={<AuditSurvellianceReport />}
          />
          <Route
            path="/renewal-status-page/reports"
            element={<RenewalStatusReport />}
          />
          <Route path="/settings" element={<SettingsMainPage/>}/>
          <Route path="/reports" element={<h1>Reports Page</h1>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
